export const serviceTypeData = [
  {
    label: "Supervised Visits",
    value: "Supervised Visits",
  },
  {
    label: "Therapeutic Visits",
    value: "Therapeutic Visits",
  },
  {
    label: "Observation and Evaluation",
    value: "Observation and Evaluation",
  },
  {
    label: "Virtual Visit",
    value: "Virtual Visit",
  },
  {
    label: "Sandwich Visits",
    value: "Sandwich Visits",
  },
  {
    label: "Home Study",
    value: "Home Study",
  },
  {
    label: "Visiting Coach",
    value: "Visiting Coach",
  },
  {
    label: "Parent Coordinator",
    value: "Parent Coordinator",
  },
  {
    label: "Supervised Access",
    value: "Supervised Access",
  },
  {
    label: "Drop Ins",
    value: "Drop Ins",
  },
  {
    label: "Advocacy",
    value: "Advocacy",
  },
  {
    label: "Other",
    value: "Other",
  },
  {
    label: "Unknown",
    value: "Unknown",
  },
];
